import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import api from "../../api/axios"; // ✅ axios centralisé
import { Grid, Button, Avatar } from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// ✅ Cellule pour afficher le nom + avatar
const NameCell = ({ row }) => (
  <Grid container alignItems="center" spacing={2}>
    {row.original.photo && (
      <Grid item>
        <Avatar
          src={row.original.photo}
          alt={row.original.name}
          style={{ width: 40, height: 40 }}
        />
      </Grid>
    )}
    <Grid item>{row.original.name}</Grid>
  </Grid>
);

NameCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      name: PropTypes.string,
      photo: PropTypes.string,
    }),
  }).isRequired,
};

// ✅ Cellule action
const ActionCell = ({ row, onAction }) => (
  <Button variant="contained" color="primary" onClick={() => onAction(row.original)}>
    Manage
  </Button>
);

ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
};

const ProductsAndServices = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/products-services/");
        console.log("products-services: ", response.data.products_services.QueryResponse.Item);
        const fetchedProducts = response.data.products_services.QueryResponse.Item || [];

        const productRows = fetchedProducts.map((product) => ({
          id: product.Id,
          name: product.Name,
          category: product.FullyQualifiedName || "Uncategorized",
          sku: product.Sku || "N/A",
          type: product.Type || "Unknown",
          price: product.UnitPrice || 0,
          cost: product.PurchaseCost || 0,
          photo: product.PhotoURL || null,
        }));

        setProducts(productRows);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleActionClick = (product) => {
    console.log("Action clicked for product:", product);
    // 👉 Ajoute ici ta logique (ex: navigation, édition, suppression)
  };

  const columns = [
    {
      Header: "Name",
      accessor: "name",
      align: "left",
      Cell: NameCell,
    },
    { Header: "Category", accessor: "category", align: "left" },
    { Header: "SKU", accessor: "sku", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Price", accessor: "price", align: "left" },
    { Header: "Cost", accessor: "cost", align: "left" },
    {
      Header: "Action",
      accessor: "action",
      align: "center",
      Cell: (props) => <ActionCell {...props} onAction={handleActionClick} />,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary">
            Add Product
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: products }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ProductsAndServices;
